import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiTrendingUp, FiTrendingDown, FiEye, FiHeart, FiMessageSquare } from 'react-icons/fi';
import './Analytics.css';

const Analytics = () => {
  const [stats, setStats] = useState(null);
  const [popularWebinars, setPopularWebinars] = useState([]);
  const [unpopularWebinars, setUnpopularWebinars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      const [statsRes, popularRes, unpopularRes] = await Promise.all([
        axios.get('/api/analytics/dashboard/'),
        axios.get('/api/analytics/popular/'),
        axios.get('/api/analytics/unpopular/'),
      ]);

      setStats(statsRes.data);
      // Убеждаемся, что данные - массивы
      setPopularWebinars(Array.isArray(popularRes.data) ? popularRes.data : []);
      setUnpopularWebinars(Array.isArray(unpopularRes.data) ? unpopularRes.data : []);
    } catch (error) {
      console.error('Analytics error:', error);
      toast.error('Ошибка загрузки аналитики');
      setPopularWebinars([]);
      setUnpopularWebinars([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="analytics-page">
      <h1>Аналитика</h1>

      <div className="analytics-stats">
        <div className="stat-box">
          <FiEye />
          <div>
            <h3>{stats?.total_views || 0}</h3>
            <p>Всего просмотров</p>
          </div>
        </div>
        <div className="stat-box">
          <FiHeart />
          <div>
            <h3>{stats?.total_likes || 0}</h3>
            <p>Всего лайков</p>
          </div>
        </div>
        <div className="stat-box">
          <FiMessageSquare />
          <div>
            <h3>{stats?.total_comments || 0}</h3>
            <p>Всего комментариев</p>
          </div>
        </div>
      </div>

      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-header">
            <h2><FiTrendingUp /> Популярные вебинары</h2>
          </div>
          <div className="webinar-ranking">
            {popularWebinars.map((webinar, index) => (
              <Link key={webinar.id} to={`/webinars/${webinar.id}`} className="ranking-item">
                <span className="rank-number">{index + 1}</span>
                <div className="rank-info">
                  <h4>{webinar.title}</h4>
                  <p>{webinar.speaker_data?.full_name}</p>
                </div>
                <div className="rank-stats">
                  <span><FiEye /> {webinar.views_count}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-header">
            <h2><FiTrendingDown /> Наименее популярные</h2>
          </div>
          <div className="webinar-ranking">
            {unpopularWebinars.map((webinar, index) => (
              <Link key={webinar.id} to={`/webinars/${webinar.id}`} className="ranking-item">
                <span className="rank-number">{index + 1}</span>
                <div className="rank-info">
                  <h4>{webinar.title}</h4>
                  <p>{webinar.speaker_data?.full_name}</p>
                </div>
                <div className="rank-stats">
                  <span><FiEye /> {webinar.views_count}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
